import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, User, Building2, ArrowRight } from "lucide-react";

export default function SubscriberTypeChooser() {
  const [params] = useSearchParams();
  const periodical_id = params.get("periodical_id") || "";
  const plan_id = params.get("plan_id") || "";
  const qs = (t) => `?periodical_id=${periodical_id}&plan_id=${plan_id}&type=${t}`;

  return (
    <div data-testid="subscriber-chooser-page" className="mx-auto max-w-3xl">
      <Button variant="ghost" size="sm" asChild className="mb-3 rounded-sm text-slate-600">
        <Link to="/subscribers"><ArrowLeft size={14} className="mr-1" />Back</Link>
      </Button>
      <h1 className="text-3xl font-semibold tracking-tight text-slate-900">New Subscriber</h1>
      <p className="mt-1 text-sm text-slate-500">Choose subscriber type to continue.</p>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Link to={`/subscribers/new/individual${qs("individual")}`} data-testid="chooser-individual"
          className="group flex flex-col rounded-sm border border-slate-200 bg-white p-6 transition-colors hover:border-[#002FA7] hover:shadow-sm">
          <div className="flex h-12 w-12 items-center justify-center rounded-sm bg-indigo-50 text-[#002FA7]"><User size={22} /></div>
          <h2 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">Individual</h2>
          <p className="mt-1 text-sm text-slate-500">Personal subscriber with name, demographics, and a postage-ready home address.</p>
          <div className="mt-6 flex items-center gap-1 text-sm font-medium text-[#002FA7]">Continue <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" /></div>
        </Link>
        <Link to={`/subscribers/new/organization${qs("organization")}`} data-testid="chooser-organization"
          className="group flex flex-col rounded-sm border border-slate-200 bg-white p-6 transition-colors hover:border-[#002FA7] hover:shadow-sm">
          <div className="flex h-12 w-12 items-center justify-center rounded-sm bg-indigo-50 text-[#002FA7]"><Building2 size={22} /></div>
          <h2 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">Organization</h2>
          <p className="mt-1 text-sm text-slate-500">Company/NGO/Trust with multiple contact persons, GST number, and bulk delivery address.</p>
          <div className="mt-6 flex items-center gap-1 text-sm font-medium text-[#002FA7]">Continue <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" /></div>
        </Link>
      </div>
    </div>
  );
}
